import { render, staticRenderFns } from "./videoPopUp.vue?vue&type=template&id=2c847977&scoped=true"
import script from "./videoPopUp.vue?vue&type=script&lang=js"
export * from "./videoPopUp.vue?vue&type=script&lang=js"
import style0 from "./videoPopUp.vue?vue&type=style&index=0&id=2c847977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c847977",
  null
  
)

export default component.exports